@if (filter) {
    <h3 class="mt-2 mb-1"
        style="text-align: center; font-family: 'Oswald'; font-size: 28px; text-transform: uppercase;">
        My @if (filter.ShowChoice == 3) {
        <span>Team's </span>
    }Tasks Due Within 45 Days</h3>
}
<div class="action-view-overview">
    @if (isLoading && !actionViewTimeout) {
        <div style="margin: auto; padding: 20px; text-align: center;">
            <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
        </div>
    }
    @if (!isLoading && !actionViewTimeout && (!tableData || tableData.length === 0)) {
        <div>
            <p class="text-center lead" style="margin-top: 20px;"><em>No current tasks</em></p>
        </div>
    }
    <div>
        @if (actionViewTimeout) {
            <p class="text-center lead" style="margin-top:20px;">
                Your data is taking some time to load. To access your Action Views,
                <span class="anchor-style" (click)="goToActionView()">click here</span>.
            </p>
        }
    </div>
    @if (!isLoading && !actionViewTimeout && tableData && tableData.length > 0) {
        <table class="task-table" style="margin: auto;">
            <thead>
                <tr>
                    <th class="name-header"></th>
                    @for (name of headerNames; track name) {
                        <th>
                            <span>{{ name }}</span>
                        </th>
                    }
                </tr>
            </thead>
            <tbody>
                @for (task of tableData; track task) {
                    <tr>
                        <td class="task-series-row-header">
                            {{ task.taskSeriesTypeName }}
                        </td>
                        @for (item of task.data; track item) {
                            <td [className]="item.colClass">
                                <span class="wide-value-badge"
                                      [tooltip]="'Ready: '+item.ready+', Not Ready: '+ item.notReady">
                                    @if (item.ready > 0) {
                                        <span (click)="drilldownCell(item, 'ready', task)">{{ item.ready }}</span>
                                    }
                                    @if (item.notReady > 0) {
                                        <span (click)="drilldownCell(item, 'not ready', task)">({{ item.notReady }})</span>
                                    }
                                </span>
                            </td>
                        }
                    </tr>
                }
            </tbody>
        </table>
    }

</div>
